/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/init-declarations */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect, useRef } from 'react';
import {
  Button, IconButton, InputAdornment, Checkbox, Tooltip, ThemeProvider, createTheme,
} from '@mui/material';
import { useMutation } from 'react-query';
import axios from 'axios';
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';
import { StyledMenu, StyledMenuItem } from 'shared-components/components/StyledComponent';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import { useSnackbar } from 'notistack';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Editor } from '@tinymce/tinymce-react';
import InputField from 'shared-components/inputs/InputField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import StradaLoader from 'shared-components/components/StradaLoader';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DeleteIcon from '@mui/icons-material/Delete';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DescriptionIcon from '@mui/icons-material/Description';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PublishIcon from '@mui/icons-material/Publish';
import EmailIcon from '@mui/icons-material/Email';
import RefreshIcon from '@mui/icons-material/Refresh';
import ShortTextIcon from '@mui/icons-material/ShortText';
import SubjectIcon from '@mui/icons-material/Subject';
// import EditIcon from '@mui/icons-material/Edit';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import LanguageIcon from '@mui/icons-material/Language';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { FilePond } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import type {
  IContent, ITasks, ISubTasks, ISendEmailData, DropResult, IOptions,
} from './types';

const customTheme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '14px',
          color: '#FFFFFFF',
          backgroundColor: '#3E3E3E',
          letterSpacing: '0.4px',
        },
      },
    },
  },
});

interface IRenderTaskContentProps {
  data: ITasks[] | undefined;
  setData: (value: ITasks[]) => void;
  focusedTask: ITasks | undefined;
  setAddChanges: (value: boolean) => void;
  addContentID: string;
  setOpenTaskAI: (value: boolean) => void;
  connectTaskSocket: boolean;
  handleTaskSocketClose: () => void;
  socketOpen: boolean;
  setFocusedTask: (value: ITasks) => void;
  setDeletedItemsIDs: (val: string[]) => void;
  deletedItemsIDs: string[];
  setTaskDetail: (value: string) => void;
}
interface IMessage {
  message: string;
}
interface IData {
  detail: IMessage;
  message: string;
  result: IMessage;
  task_id: string;
}
interface IResponse {
  data: IData;
}
interface Ipayload {
  user_message: string;
  instruction: string | null;
  previous_response: string;
  retry: boolean;
}

function MergeTagIcon(): JSX.Element {
  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.5 3.57812L9.98438 4.98438L8.57812 2.5L9.98438 0.015625L7.5 1.42188L5.01562 0.015625L6.42188 2.5L5.01562 4.98438L7.5 3.57812ZM19.5 13.4219L17.0156 12.0156L18.4219 14.5L17.0156 16.9844L19.5 15.5781L21.9844 16.9844L20.5781 14.5L21.9844 12.0156L19.5 13.4219ZM21.9844 0.015625L19.5 1.42188L17.0156 0.015625L18.4219 2.5L17.0156 4.98438L19.5 3.57812L21.9844 4.98438L20.5781 2.5L21.9844 0.015625ZM14.3906 5.3125C14.1719 5.09375 13.9219 4.98438 13.6406 4.98438C13.3906 4.98438 13.1562 5.09375 12.9375 5.3125L1.3125 16.9375C1.09375 17.1562 0.984375 17.4062 0.984375 17.6875C0.984375 17.9375 1.09375 18.1719 1.3125 18.3906L3.60938 20.6875C3.82812 20.9062 4.0625 21.0156 4.3125 21.0156C4.59375 21.0156 4.84375 20.9062 5.0625 20.6875L16.6875 9.0625C16.9062 8.84375 17.0156 8.60938 17.0156 8.35938C17.0156 8.07812 16.9062 7.84375 16.6875 7.65625L14.3906 5.3125ZM13.3594 10.7969L11.2031 8.64062L13.6406 6.20312L15.7969 8.35938L13.3594 10.7969Z' fill='#212121' fillOpacity='0.6' />
    </svg>
  );
}
function AIIcon(): JSX.Element {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.0117 6.75C15.4102 6.75 15.7734 6.85547 16.1016 7.06641C16.4531 7.25391 16.7344 7.52344 16.9453 7.875C17.1562 8.20312 17.2617 8.57812 17.2617 9C17.2617 9.42188 17.1562 9.80859 16.9453 10.1602C16.7344 10.4883 16.4531 10.7578 16.1016 10.9688C15.7734 11.1562 15.4102 11.25 15.0117 11.25V14.2383C15.0117 14.6602 14.8594 15.0234 14.5547 15.3281C14.2734 15.6094 13.9219 15.75 13.5 15.75H4.5C4.07812 15.75 3.71484 15.6094 3.41016 15.3281C3.12891 15.0234 2.98828 14.6602 2.98828 14.2383V11.25C2.58984 11.25 2.21484 11.1562 1.86328 10.9688C1.53516 10.7578 1.26562 10.4883 1.05469 10.1602C0.84375 9.80859 0.738281 9.42188 0.738281 9C0.738281 8.57812 0.84375 8.20312 1.05469 7.875C1.26562 7.52344 1.53516 7.25391 1.86328 7.06641C2.21484 6.85547 2.58984 6.75 2.98828 6.75V5.23828C2.98828 4.83984 3.12891 4.5 3.41016 4.21875C3.71484 3.91406 4.07812 3.76172 4.5 3.76172H6.75C6.75 3.33984 6.84375 2.96484 7.03125 2.63672C7.24219 2.28516 7.51172 2.01562 7.83984 1.82812C8.19141 1.61719 8.57812 1.51172 9 1.51172C9.42188 1.51172 9.79688 1.61719 10.125 1.82812C10.4766 2.01562 10.7461 2.28516 10.9336 2.63672C11.1445 2.96484 11.25 3.33984 11.25 3.76172H13.5C13.9219 3.76172 14.2734 3.91406 14.5547 4.21875C14.8594 4.5 15.0117 4.83984 15.0117 5.23828V6.75ZM5.625 8.61328C5.625 8.94141 5.73047 9.21094 5.94141 9.42188C6.17578 9.63281 6.44531 9.73828 6.75 9.73828C7.05469 9.73828 7.3125 9.63281 7.52344 9.42188C7.75781 9.21094 7.875 8.94141 7.875 8.61328C7.875 8.30859 7.75781 8.05078 7.52344 7.83984C7.3125 7.60547 7.05469 7.48828 6.75 7.48828C6.44531 7.48828 6.17578 7.60547 5.94141 7.83984C5.73047 8.05078 5.625 8.30859 5.625 8.61328ZM11.9883 12.7617V11.25H6.01172V12.7617H11.9883ZM11.25 9.73828C11.5547 9.73828 11.8125 9.63281 12.0234 9.42188C12.2578 9.21094 12.375 8.94141 12.375 8.61328C12.375 8.30859 12.2578 8.05078 12.0234 7.83984C11.8125 7.60547 11.5547 7.48828 11.25 7.48828C10.9453 7.48828 10.6758 7.60547 10.4414 7.83984C10.2305 8.05078 10.125 8.30859 10.125 8.61328C10.125 8.94141 10.2305 9.21094 10.4414 9.42188C10.6758 9.63281 10.9453 9.73828 11.25 9.73828Z' fill='#212121' fillOpacity='0.87' />
    </svg>
  );
}
function AIIconDisabled(): JSX.Element {
  return (
    <svg width='18' height='15' viewBox='0 0 18 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M15.0117 5.75C15.4102 5.75 15.7734 5.85547 16.1016 6.06641C16.4531 6.25391 16.7344 6.52344 16.9453 6.875C17.1562 7.20312 17.2617 7.57812 17.2617 8C17.2617 8.42188 17.1562 8.80859 16.9453 9.16016C16.7344 9.48828 16.4531 9.75781 16.1016 9.96875C15.7734 10.1562 15.4102 10.25 15.0117 10.25V13.2383C15.0117 13.6602 14.8594 14.0234 14.5547 14.3281C14.2734 14.6094 13.9219 14.75 13.5 14.75H4.5C4.07812 14.75 3.71484 14.6094 3.41016 14.3281C3.12891 14.0234 2.98828 13.6602 2.98828 13.2383V10.25C2.58984 10.25 2.21484 10.1562 1.86328 9.96875C1.53516 9.75781 1.26562 9.48828 1.05469 9.16016C0.84375 8.80859 0.738281 8.42188 0.738281 8C0.738281 7.57812 0.84375 7.20312 1.05469 6.875C1.26562 6.52344 1.53516 6.25391 1.86328 6.06641C2.21484 5.85547 2.58984 5.75 2.98828 5.75V4.23828C2.98828 3.83984 3.12891 3.5 3.41016 3.21875C3.71484 2.91406 4.07812 2.76172 4.5 2.76172H6.75C6.75 2.33984 6.84375 1.96484 7.03125 1.63672C7.24219 1.28516 7.51172 1.01562 7.83984 0.828125C8.19141 0.617188 8.57812 0.511719 9 0.511719C9.42188 0.511719 9.79688 0.617188 10.125 0.828125C10.4766 1.01562 10.7461 1.28516 10.9336 1.63672C11.1445 1.96484 11.25 2.33984 11.25 2.76172H13.5C13.9219 2.76172 14.2734 2.91406 14.5547 3.21875C14.8594 3.5 15.0117 3.83984 15.0117 4.23828V5.75ZM5.625 7.61328C5.625 7.94141 5.73047 8.21094 5.94141 8.42188C6.17578 8.63281 6.44531 8.73828 6.75 8.73828C7.05469 8.73828 7.3125 8.63281 7.52344 8.42188C7.75781 8.21094 7.875 7.94141 7.875 7.61328C7.875 7.30859 7.75781 7.05078 7.52344 6.83984C7.3125 6.60547 7.05469 6.48828 6.75 6.48828C6.44531 6.48828 6.17578 6.60547 5.94141 6.83984C5.73047 7.05078 5.625 7.30859 5.625 7.61328ZM11.9883 11.7617V10.25H6.01172V11.7617H11.9883ZM11.25 8.73828C11.5547 8.73828 11.8125 8.63281 12.0234 8.42188C12.2578 8.21094 12.375 7.94141 12.375 7.61328C12.375 7.30859 12.2578 7.05078 12.0234 6.83984C11.8125 6.60547 11.5547 6.48828 11.25 6.48828C10.9453 6.48828 10.6758 6.60547 10.4414 6.83984C10.2305 7.05078 10.125 7.30859 10.125 7.61328C10.125 7.94141 10.2305 8.21094 10.4414 8.42188C10.6758 8.63281 10.9453 8.73828 11.25 8.73828Z' fill='#212121' fillOpacity='0.38' />
    </svg>
  );
}
function hanldeAddMergeTag(mergeFieldType: string, editorEdit: boolean, editorRefs: any, mergeFieldPosition: number, sendEmaildata: IContent, labelKey: string | undefined, data: ITasks[], setData: (value: ITasks[]) => void, focusedTask: ITasks, setAddChanges: (value: boolean) => void, index: number): void {
  if (data !== undefined && focusedTask !== undefined) {
    setData(data.map((task: ITasks) => {
      if (task.unique_position_key === focusedTask.unique_position_key) {
        task.content.map((item: IContent, indx: number) => {
          if (index === indx && item.sendEmailData !== undefined && labelKey !== undefined) {
            if (editorEdit && mergeFieldType === 'body') {
              editorRefs.current[item.unique_position_key].editor.execCommand('mceInsertContent', false, `{{form.${labelKey.slice(0, 29)}}}`);
              item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData] = editorRefs.current[item.unique_position_key].getContent();
            } else if (labelKey.length > 30) {
              if (mergeFieldPosition !== -1) {
                item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData] = `${item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData].substring(0, mergeFieldPosition)}{{form.${labelKey.slice(0, 29)}}}${item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData].substring(mergeFieldPosition)}`;
              } else {
                item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData] += `{{form.${labelKey.slice(0, 29)}}}`;
              }
            } else if (mergeFieldPosition !== -1) {
              item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData] = `${item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData].substring(0, mergeFieldPosition)}{{form.${labelKey.slice(0, 29)}}}${item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData].substring(mergeFieldPosition)}`;
            } else {
              item.sendEmailData[`${mergeFieldType}` as keyof ISendEmailData] += `{{form.${labelKey.slice(0, 29)}}}`;
            }
          }
        });
      }
      return task;
    }));
    setAddChanges(true);
  }
}
function renderMergeTagList(mergeFieldType: string, editorEdit: boolean, editorRefs: any, mergeFieldPosition: number, item: IContent, data: ITasks[] | undefined, setData: (value: ITasks[]) => void, focusedTask: ITasks, setAddChanges: (value: boolean) => void, index: number): JSX.Element {
  let emailFieldsExist = false;
  let formFieldsExist = false;
  return (
    <div>
      {data !== undefined ? data.map((task) => task.content.map((contentt) => {
        if (contentt.type === 'form' && contentt.form_type !== 'fileUpload' && contentt.form_type !== 'image' && (mergeFieldType === 'subject' || mergeFieldType === 'body')) {
          formFieldsExist = true;
          return <StyledMenuItem className='mergetag-menu-item' onClick={(): void => { hanldeAddMergeTag(mergeFieldType, editorEdit, editorRefs, mergeFieldPosition, item, contentt.label_key, data, setData, focusedTask, setAddChanges, index); }}><span className='btn-txt'>{contentt.label}</span></StyledMenuItem>;
        } if (contentt.type === 'form' && contentt.form_type === 'email') {
          emailFieldsExist = true;
          formFieldsExist = true;
          return <StyledMenuItem className='mergetag-menu-item' onClick={(): void => { hanldeAddMergeTag(mergeFieldType, editorEdit, editorRefs, mergeFieldPosition, item, contentt.label_key, data, setData, focusedTask, setAddChanges, index); }}><span className='btn-txt'>{contentt.label}</span></StyledMenuItem>;
        }
        return null;
      })) : null}
      {!emailFieldsExist && mergeFieldType !== 'subject' && mergeFieldType !== 'body'
        ? <StyledMenuItem className='mergetag-menu-item'><span className='btn-txt'>No Form Field Exist</span></StyledMenuItem>
        : !formFieldsExist
          ? <StyledMenuItem className='mergetag-menu-item'><span className='btn-txt'>No Form Field Exist</span></StyledMenuItem>
          : null}
    </div>
  );
}

export default function RenderTaskContent(props: IRenderTaskContentProps): JSX.Element {
  const {
    data, setData, focusedTask, setAddChanges, socketOpen, addContentID, setOpenTaskAI, connectTaskSocket, handleTaskSocketClose, setFocusedTask, setDeletedItemsIDs, deletedItemsIDs, setTaskDetail,
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [editorLoader, setEditorLoader] = useState<boolean>(true);
  const [selectedContentItem, setSelectedContentItem] = useState<IContent>();
  const [openDeleteContentBlock, setOpenDeleteContentBlock] = useState<boolean>(false);
  const [mergeFieldType, setMergeFieldType] = useState<string>('');
  const [mergeFieldPosition, setMergeFieldPosition] = useState<number>(-1);
  const [editorEdit, setEditorEdit] = useState(false);
  const [mergeTagAnchorEl, setMergeTagAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [showSubtaskInputIndex, setShowSubtaskInputIndex] = useState<number>(-1);
  const [showDropdownInputIndex, setShowDropdownInputIndex] = useState<number>(-1);
  const [showRadioInputIndex, setShowRadioInputIndex] = useState<number>(-1);
  const [showMultichoiceInputIndex, setShowMultichoiceInputIndex] = useState<number>(-1);
  const [formItemkey, setFormItemkey] = useState<string>('');
  const [emailItem, setEmailItem] = useState<IContent | undefined>();
  const [sendEmailIndex, setSendEmailIndex] = useState<number>(0);
  const [emailLoader, setEmailLoader] = useState<boolean>(false);

  const bottomRef = useRef<HTMLDivElement | null>(null);
  const editorRefs = useRef<any>([]);
  const scollToRef = useRef<HTMLInputElement>(null);
  function handleChangeEditorContent(editor_content: string, editordata: IContent): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === editordata.unique_position_key) {
              item.value = editor_content;
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function swapWithUpperContent(content_index: number): void {
    if (data !== undefined && focusedTask !== undefined) {
      if (content_index !== 0) {
        setData(data.map((task: ITasks) => {
          if (task.unique_position_key === focusedTask.unique_position_key) {
            const temp = task.content[content_index - 1];
            task.content[content_index - 1] = task.content[content_index];
            task.content[content_index] = temp;
            setFocusedTask(task);
          }
          return task;
        }));
        setAddChanges(true);
      }
    }
  }
  function swapWithLowerContent(content_index: number): void {
    if (data !== undefined && focusedTask !== undefined) {
      const index = data.findIndex((task) => task.unique_position_key === focusedTask.unique_position_key);
      if (content_index !== data[index].content.length - 1) {
        setData(data.map((task: ITasks) => {
          if (task.unique_position_key === focusedTask.unique_position_key) {
            const temp = task.content[content_index + 1];
            task.content[content_index + 1] = task.content[content_index];
            task.content[content_index] = temp;
            setFocusedTask(task);
          }
          return task;
        }));
        setAddChanges(true);
      }
    }
  }
  function deleteTaskItem(itemData: IContent | undefined): void {
    if (data !== undefined && focusedTask !== undefined) {
      if (itemData !== undefined) {
        const index = data.findIndex((task) => task.unique_position_key === focusedTask.unique_position_key);
        const index2 = data[index].content.findIndex((item) => item.unique_position_key === itemData.unique_position_key);
        setData(data.map((task: ITasks, indx) => {
          if (index === indx) {
            task.content.splice(index2, 1);
            setFocusedTask(task);
          }
          return task;
        }));
        setDeletedItemsIDs([...deletedItemsIDs, itemData.unique_position_key]);
        setAddChanges(true);
        setOpenDeleteContentBlock(false);
      }
    }
  }
  function duplicateContentItem(seletedContent: IContent): void {
    if (data !== undefined && focusedTask !== undefined) {
      const obj: IContent = JSON.parse(JSON.stringify(seletedContent));
      obj.unique_position_key = Date.now().toString();
      delete obj.id;
      if (obj.type === 'subTask' && obj.subTasks !== undefined) {
        obj.subTasks.map((subtask: ISubTasks) => {
          delete subtask.id;
        });
      }
      if (obj.type === 'file') {
        obj.is_duplicate = true;
        obj.is_new = false;
      }
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          const index = task.content.findIndex((item) => item.unique_position_key === seletedContent.unique_position_key);
          task.content.splice(index, 0, obj);
          setFocusedTask(task);
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function handleFileClick(fileId: string): void {
    document.getElementById(fileId)?.click();
  }
  async function file2Base64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (): void => { resolve(reader.result !== null && typeof reader.result === 'string' ? reader.result.toString() : ''); };
      reader.onerror = (error): void => { reject(error); };
    });
  }
  async function onProcessAttachment(addedFile: File, fileitem: IContent): Promise<string> {
    const base64 = await file2Base64(addedFile).then((res): string => {
      const obj = {
        file: res,
        file_name: addedFile.name,
      };
      if (data !== undefined && focusedTask !== undefined) {
        setData(data.map((task: ITasks) => {
          if (task.unique_position_key === focusedTask.unique_position_key) {
            task.content.map((item: IContent) => {
              if (item.unique_position_key === fileitem.unique_position_key) {
                item.files = obj;
                item.is_new = true;
                item.is_duplicate = false;
              }
            });
          }
          return task;
        }));
        setAddChanges(true);
      }
      return res;
    });
    return base64;
  }
  function handleDescriptionChange(e: React.ChangeEvent<HTMLInputElement>, descItem: IContent): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === descItem.unique_position_key) {
              item.description = e.target.value;
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function handleSendEmailChange(e: React.ChangeEvent<HTMLInputElement> | string, sendEmaildata: IContent): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === sendEmaildata.unique_position_key && item.sendEmailData !== undefined) {
              if (typeof e === 'string') {
                item.sendEmailData.body = e;
              } else {
                item.sendEmailData[e.target.name as keyof ISendEmailData] = e.target.value;
              }
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function handleSubTaskInputChange(value: string, subTaskItem: IContent, subTaskInnerItem: ISubTasks): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === subTaskItem.unique_position_key && item.subTasks !== undefined) {
              item.subTasks.map((subTasksItem: ISubTasks) => {
                if (subTasksItem.unique_position_key === subTaskInnerItem.unique_position_key) {
                  subTasksItem.value = value;
                }
              });
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function addNewSubTask(subTaskItem: IContent, subTaskItemIndex: number): void {
    if (data !== undefined && focusedTask !== undefined) {
      const obj = {
        unique_position_key: Date.now().toString(),
        // isTrue:false,
        value: '',
      };
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === subTaskItem.unique_position_key && item.subTasks !== undefined) {
              item.subTasks.splice(subTaskItemIndex + 1, 0, obj);
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
      setShowSubtaskInputIndex(subTaskItemIndex + 1);
    }
  }
  function handleIsRequiredCheckbox(subTaskItem: IContent): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === subTaskItem.unique_position_key && item.is_required !== undefined) {
              item.is_required = !item.is_required;
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function handleFormLabelChange(label: string, formItem: IContent): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === formItem.unique_position_key) {
              item.label = label;
              item.label_key = `${label.toLowerCase().replaceAll(' ', '_')}_${item.unique_position_key.toString().slice(-4)}`;
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function handleOption(label: string, formItem: IContent, singleOption: IOptions): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === formItem.unique_position_key && item.options !== undefined) {
              item.options.map((option: IOptions) => {
                if (option.unique_position_key === singleOption.unique_position_key) {
                  option.label = label;
                }
              });
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function addNewOption(dropdownItem: IContent, dropdownItemIndex: number): void {
    if (data !== undefined && focusedTask !== undefined) {
      const obj = {
        unique_position_key: Date.now().toString(),
        // isTrue:false,
        label: '',
      };
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === dropdownItem.unique_position_key && item.options !== undefined) {
              item.options.splice(dropdownItemIndex + 1, 0, obj);
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
      if (dropdownItem.form_type === 'dropdown') {
        setShowDropdownInputIndex(dropdownItemIndex + 1);
      } else if (dropdownItem.form_type === 'radio') {
        setShowRadioInputIndex(dropdownItemIndex + 1);
      } else {
        setShowMultichoiceInputIndex(dropdownItemIndex + 1);
      }
    }
  }
  function removeOption(dropdownItem: IContent, dropdownItemIndex: number): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === dropdownItem.unique_position_key && item.options !== undefined && item.options.length > 1) {
              item.options.splice(dropdownItemIndex, 1);
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  function removeSubtaskOption(dropdownItem: IContent, subTaskItemIndex: number): void {
    if (data !== undefined && focusedTask !== undefined) {
      setData(data.map((task: ITasks) => {
        if (task.unique_position_key === focusedTask.unique_position_key) {
          task.content.map((item: IContent) => {
            if (item.unique_position_key === dropdownItem.unique_position_key && item.subTasks !== undefined && item.subTasks.length > 1) {
              item.subTasks.splice(subTaskItemIndex, 1);
            }
          });
        }
        return task;
      }));
      setAddChanges(true);
    }
  }
  const { mutate: getEmailCeleryProgress } = useMutation(async (taskID: string) => axios({
    url: `/api/chat-gpt/task_progress/?task_id=${taskID}`,
    method: 'get',
  }), {
    onSuccess: (res, taskID) => {
      if (res.data.detail.progress.percent !== 100 || res.data.detail.result === undefined) {
        setTimeout((): void => {
          getEmailCeleryProgress(taskID);
        }, 1000);
      } else if (typeof res.data.detail.result === 'string') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        enqueueSnackbar(res.data.detail.result);
        setEmailLoader(false);
      } else if (res.data.detail.result.message !== undefined) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        enqueueSnackbar(res.data.detail.result.message);
        setEmailLoader(false);
      } else if (emailItem !== undefined) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        handleSendEmailChange(res.data.detail.result.email.message, emailItem);
        setEmailLoader(false);
        enqueueSnackbar('Email generated by AI');
      }
    },
    onError: (err: IResponse) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      enqueueSnackbar(err.data.detail.message, {
        variant: 'error',
        content: (key, message) => (
          <div className='text-white bg-danger ps-4 pe-5 py-3'>
            {message}
          </div>
        ),
      });
      setEmailLoader(false);
    },
  });
  const { mutate: generateEmailWithAI } = useMutation(async (emailData: Ipayload) => axios({
    url: 'api/chat-gpt/generate-email/',
    method: 'post',
    data: emailData,
  }), {
    onSuccess: (res) => {
      setEmailLoader(true);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      getEmailCeleryProgress(res.data.detail.task_id);
    },
    onError: () => {
      setEmailLoader(false);
      enqueueSnackbar('Error in generating email with AI', {
        variant: 'error',
        content: (key, message) => (
          <div className='text-white bg-danger ps-4 pe-5 py-3'>
            {message}
          </div>
        ),
      });
    },
  });

  function reorder(list: IContent[], startIndex: number, endIndex: number | undefined): IContent[] {
    const result = Array.from(list);
    if (endIndex !== undefined) {
      const [removed] = result.splice(startIndex, 1);
      result.splice(endIndex, 0, removed);
    }
    return result;
  }
  function onContentDragEnd(result: DropResult): void {
    if (data !== undefined && focusedTask !== undefined) {
      if (result.destination !== undefined) {
        setData(data.map((task: ITasks) => {
          if (task.unique_position_key === focusedTask.unique_position_key) {
            task.content = reorder(task.content, result.source.index, result.destination?.index);
            setFocusedTask(task);
          }
          return task;
        }));
        setAddChanges(true);
      }
    }
  }
  useEffect(() => {
    if (bottomRef.current !== null && addContentID !== '') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [addContentID]);

  const handleInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement> | React.KeyboardEvent<HTMLTextAreaElement>): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };
  const getCursorIndex = (field: HTMLElement | HTMLInputElement | null): void => {
    const inputFiled = field as HTMLInputElement;
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (inputFiled !== null && inputFiled.selectionStart !== null) {
      setMergeFieldPosition(inputFiled.selectionStart);
    } else {
      setMergeFieldPosition(-1);
    }
  };
  useEffect(() => {
    scollToRef?.current?.scrollIntoView();
  }, [focusedTask?.content?.length]);
  return (
    <div className='task-form-wrapper'>
      <div style={{ height: 'auto', overflow: 'scroll' }}>
        {focusedTask !== undefined && focusedTask.content.length > 0 ? (
          <DragDropContext onDragEnd={(result: DropResult): void => { onContentDragEnd(result); }}>
            <Droppable droppableId='11223344'>
              {(provided): JSX.Element => (
                <div ref={provided.innerRef}>
                  {focusedTask.content.map((item: IContent, index) => (
                    <Draggable draggableId={String(item.unique_position_key)} key={String(item.unique_position_key)} index={index}>
                      {(provideed): JSX.Element => (
                        <div ref={provideed.innerRef} {...provideed.draggableProps} {...provideed.dragHandleProps}>
                          {item.type === 'text' ? (
                            <div className='task-form-item' key={item.unique_position_key}>
                              <div className='editor-wrapper'>
                                <div className='swap-up-down-wrapper'>
                                  <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                  <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                </div>
                                <div className='editor-div' style={{ overflow: 'scroll' }}>
                                  <div className='loader-div'><StradaLoader open={editorLoader} /></div>
                                  <Editor
                                    apiKey='1y7zut3pxyomlx5vhlj7wuh2q7r7sd4w8x7oevrxn05o07fq'
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`index-${index}`}
                                    onLoadContent={(): void => { setEditorLoader(false); }}
                                    init={{
                                      height: 150,
                                      branding: false,
                                      menubar: false,
                                      toolbar_mode: 'scrolling',
                                      skin: 'material-outline',
                                      content_css: 'material-outline',
                                      plugins: [
                                        'advlist autolink lists link image charmap print preview anchor',
                                        'searchreplace visualblocks code fullscreen',
                                        'insertdatetime media table paste code help ',
                                      ],
                                      toolbar: 'undo redo | styleselect | fontsizeselect | backcolor | bold italic underline|  bullist numlist | outdent indent',
                                      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px;line-height: 1;} ',
                                    }}
                                    value={item.value}
                                    onEditorChange={(content: string): void => { handleChangeEditorContent(content, item); }}
                                  />
                                </div>
                                <div className='delete-duplicate-wrapper'>
                                  <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                  <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                </div>
                              </div>
                            </div>
                          ) : item.type === 'file'
                            ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  {item.files !== undefined && item.files.file_name !== ''
                                    ? (
                                      <div style={{ width: '100%' }}>
                                        <div className='file-div'>
                                          <DescriptionIcon />
                                          <div style={{ width: '100%' }}>
                                            <h6>{item.files.file_name}</h6>
                                            <p>PDF</p>
                                          </div>
                                          {item.id !== undefined
                                            && (
                                              <PopupState variant='popper' popupId='demo-popup-popper'>
                                                {(popupState): JSX.Element => (
                                                  <div>
                                                    <IconButton {...bindToggle(popupState)}>
                                                      <MoreVertIcon fontSize='inherit' />
                                                    </IconButton>
                                                    <Popper {...bindPopper(popupState)} transition style={{ zIndex: '10000' }}>
                                                      {({ TransitionProps }): JSX.Element => (
                                                        <ClickAwayListener
                                                          onClickAway={(): void => {
                                                            popupState.close();
                                                          }}
                                                        >
                                                          <Fade {...TransitionProps} timeout={350}>
                                                            <Paper className='checklist-list-popover'>
                                                              <a style={{ textDecoration: 'none' }} href={`${process.env.REACT_APP_IMAGE_URL}/${item.files !== undefined ? item.files.file : ''}`}>
                                                                <div
                                                                  className='chart-btn'
                                                                  onClick={(): void => {
                                                                    popupState.close();
                                                                  }}
                                                                  aria-hidden='true'
                                                                >
                                                                  <span className='edit-delete-text'>
                                                                    Download
                                                                  </span>
                                                                </div>
                                                              </a>
                                                            </Paper>
                                                          </Fade>
                                                        </ClickAwayListener>
                                                      )}
                                                    </Popper>
                                                  </div>
                                                )}
                                              </PopupState>
                                            )}
                                        </div>
                                        <div className='file-description-div'>
                                          <InputField
                                            name='name'
                                            label='Description(optional)'
                                            type='text'
                                            onKeyDown={handleInputKeyDown}
                                            inputProps={{ maxLength: 250 }}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleDescriptionChange(e, item); }}
                                            value={item.description}
                                          />
                                        </div>
                                      </div>
                                    )
                                    : (
                                      <div className='file-input-wrap'>
                                        <input
                                          type='file'
                                          name='file'
                                          id={`selectImage${item.unique_position_key}`}
                                          style={{ display: 'none' }}
                                          onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                                            if (e.target.files === null) return;
                                            if (e.target.files[0].size <= 30 * 1024 * 1024) {
                                              onProcessAttachment(e.target.files[0], item).then(
                                                () => { },
                                                () => { },
                                              );
                                            } else {
                                              enqueueSnackbar('File size exceeds the limit of 30MB.', {
                                                variant: 'error',
                                                content: (key, message) => (
                                                  <div className='text-white bg-danger ps-4 pe-5 py-3'>
                                                    {message}
                                                  </div>
                                                ),
                                              });
                                            }
                                          }}
                                        />
                                        <div className='file-input-div' aria-hidden='true' onClick={(): void => { handleFileClick(`selectImage${item.unique_position_key}`); }}>
                                          <PublishIcon />
                                          <p>Upload file</p>
                                        </div>
                                      </div>
                                    )}
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.type === 'sendEmail' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%', overflow: 'scroll' }}>
                                    <div className='sendEmail-input-wrap'>
                                      <InputField
                                        id={`${item.unique_position_key}to`}
                                        name='to'
                                        label='To'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleSendEmailChange(e, item); }}
                                        value={item.sendEmailData !== undefined ? item.sendEmailData.to : ''}
                                        endAdornment={(
                                          <InputAdornment position='end'>
                                            <IconButton onClick={(event: React.MouseEvent<HTMLButtonElement>): void => { setMergeTagAnchorEl(event.currentTarget); setMergeFieldType('to'); getCursorIndex(document.getElementById(`${item.unique_position_key}to`)); setSendEmailIndex(index); }}>
                                              <MergeTagIcon />
                                            </IconButton>
                                          </InputAdornment>
                                        )}
                                      />
                                    </div>
                                    <div className='sendEmail-input-wrap'>
                                      <InputField
                                        id={`${item.unique_position_key}cc`}
                                        name='cc'
                                        label='Cc'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleSendEmailChange(e, item); }}
                                        value={item.sendEmailData !== undefined ? item.sendEmailData.cc : ''}
                                        error={false}
                                        endAdornment={(
                                          <InputAdornment position='end'>
                                            <IconButton onClick={(event: React.MouseEvent<HTMLButtonElement>): void => { setMergeTagAnchorEl(event.currentTarget); setMergeFieldType('cc'); getCursorIndex(document.getElementById(`${item.unique_position_key}cc`)); setSendEmailIndex(index); }}>
                                              <MergeTagIcon />
                                            </IconButton>
                                          </InputAdornment>
                                        )}
                                      />
                                    </div>
                                    <div className='sendEmail-input-wrap'>
                                      <InputField
                                        id={`${item.unique_position_key}bcc`}
                                        name='bcc'
                                        label='Bcc'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleSendEmailChange(e, item); }}
                                        value={item.sendEmailData !== undefined ? item.sendEmailData.bcc : ''}
                                        endAdornment={(
                                          <InputAdornment position='end'>
                                            <IconButton onClick={(event: React.MouseEvent<HTMLButtonElement>): void => { setMergeTagAnchorEl(event.currentTarget); setMergeFieldType('bcc'); getCursorIndex(document.getElementById(`${item.unique_position_key}bcc`)); setSendEmailIndex(index); }}>
                                              <MergeTagIcon />
                                            </IconButton>
                                          </InputAdornment>
                                        )}
                                      />
                                    </div>
                                    <div className='sendEmail-input-wrap'>
                                      <InputField
                                        id={`${item.unique_position_key}subject`}
                                        name='subject'
                                        label='Subject'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleSendEmailChange(e, item); }}
                                        value={item.sendEmailData !== undefined ? item.sendEmailData.subject : ''}
                                        error={false}
                                        endAdornment={(
                                          <InputAdornment position='end'>
                                            <IconButton onClick={(event: React.MouseEvent<HTMLButtonElement>): void => { setMergeTagAnchorEl(event.currentTarget); setMergeFieldType('subject'); getCursorIndex(document.getElementById(`${item.unique_position_key}subject`)); setSendEmailIndex(index); }}>
                                              <MergeTagIcon />
                                            </IconButton>
                                          </InputAdornment>
                                        )}
                                      />
                                    </div>
                                    <div className='file-description-div'>
                                      <div style={{ marginLeft: '6%' }}><StradaLoader open={editorLoader} /></div>
                                      <div style={{ display: 'flex' }}>
                                        <div style={{ width: '90%' }}>
                                          <Editor
                                            apiKey='1y7zut3pxyomlx5vhlj7wuh2q7r7sd4w8x7oevrxn05o07fq'
                                            onLoadContent={(): void => { setEditorLoader(false); }}
                                            init={{
                                              height: 150,
                                              branding: false,
                                              menubar: false,
                                              toolbar_mode: 'scrolling',
                                              width: '100%',
                                              skin: 'material-outline',
                                              content_css: 'material-outline',
                                              plugins: [
                                                'advlist autolink lists link image charmap print preview anchor',
                                                'searchreplace visualblocks code fullscreen',
                                                'insertdatetime media table paste code help ',
                                              ],
                                              toolbar: 'undo redo | styleselect | fontsizeselect | backcolor | bold italic underline|  bullist numlist | outdent indent',
                                              content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px;line-height: 1;} ',
                                            }}
                                            value={item.sendEmailData !== undefined ? item.sendEmailData.body : ''}
                                            onEditorChange={(content: string): void => { handleSendEmailChange(content, item); }}
                                            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                                            ref={(el) => (editorRefs.current[item.unique_position_key] = el)}
                                          />
                                        </div>
                                        <div className='d-flex align-items-center flex-column' style={{ width: '10%' }}>
                                          <IconButton className='merge-tag-div mb-2' onClick={(event: React.MouseEvent<HTMLButtonElement>): void => { setMergeTagAnchorEl(event.currentTarget); setMergeFieldType('body'); setEditorEdit(true); setSendEmailIndex(index); }}>
                                            <MergeTagIcon />
                                          </IconButton>
                                          {item.sendEmailData !== undefined && item.sendEmailData.subject !== '' && focusedTask.name !== '' && focusedTask.name !== null
                                            ? (
                                              <div>
                                                {emailLoader
                                                  ? <StradaLoader open={emailLoader} />
                                                  : (
                                                    <PopupState variant='popper' popupId='demo-popup-popper'>
                                                      {(popupState): JSX.Element => (
                                                        <div aria-hidden='true' onClick={(): void => { setEmailItem(item); }}>
                                                          <IconButton className='merge-tag-div' {...bindToggle(popupState)}>
                                                            <AIIcon />
                                                          </IconButton>
                                                          <Popper
                                                            {...bindPopper(popupState)}
                                                            transition
                                                          >
                                                            {({ TransitionProps }): JSX.Element => (
                                                              <ClickAwayListener onClickAway={(): void => { popupState.close(); }}>
                                                                <Fade {...TransitionProps} timeout={350}>
                                                                  <Paper className='ai-popover'>
                                                                    <div
                                                                      className='chart-btn'
                                                                      style={{ borderBottom: '1px solid #E4E4E4' }}
                                                                      onClick={(): void => {
                                                                        popupState.close();
                                                                        item.sendEmailData !== undefined
                                                                          && generateEmailWithAI(
                                                                            {
                                                                              user_message: item.sendEmailData.subject, instruction: null, previous_response: item.sendEmailData.body, retry: !!item.sendEmailData.body,
                                                                            },
                                                                          );
                                                                      }}
                                                                      aria-hidden='true'
                                                                    >
                                                                      <RefreshIcon />
                                                                      <span className='ms-3'>Generate</span>
                                                                    </div>
                                                                    <h6>LENGTH</h6>
                                                                    <div
                                                                      className='chart-btn'
                                                                      onClick={(): void => {
                                                                        popupState.close();
                                                                        item.sendEmailData !== undefined
                                                                          && generateEmailWithAI(
                                                                            {
                                                                              user_message: item.sendEmailData.subject, instruction: 'shorter', previous_response: item.sendEmailData.body, retry: !!item.sendEmailData.body,
                                                                            },
                                                                          );
                                                                      }}
                                                                      aria-hidden='true'
                                                                    >
                                                                      <ShortTextIcon />
                                                                      <span className='ms-3'>Make shorter</span>
                                                                    </div>
                                                                    <div
                                                                      className='chart-btn'
                                                                      onClick={(): void => {
                                                                        popupState.close();
                                                                        item.sendEmailData !== undefined
                                                                          && generateEmailWithAI(
                                                                            {
                                                                              user_message: item.sendEmailData.subject, instruction: 'longer', previous_response: item.sendEmailData.body, retry: !!item.sendEmailData.body,
                                                                            },
                                                                          );
                                                                      }}
                                                                      style={{ borderBottom: '1px solid #E4E4E4' }}
                                                                      aria-hidden='true'
                                                                    >
                                                                      <SubjectIcon />
                                                                      <span className='ms-3'>Make longer</span>
                                                                    </div>
                                                                    <h6>TONE</h6>
                                                                    <div
                                                                      className='chart-btn'
                                                                      onClick={(): void => {
                                                                        popupState.close();
                                                                        item.sendEmailData !== undefined
                                                                          && generateEmailWithAI(
                                                                            {
                                                                              user_message: item.sendEmailData.subject, instruction: 'formal', previous_response: item.sendEmailData.body, retry: !!item.sendEmailData.body,
                                                                            },
                                                                          );
                                                                      }}
                                                                      aria-hidden='true'
                                                                    >
                                                                      <ChatBubbleIcon />
                                                                      <span className='ms-3'>More formal</span>
                                                                    </div>
                                                                    <div
                                                                      className='chart-btn'
                                                                      onClick={(): void => {
                                                                        popupState.close();
                                                                        item.sendEmailData !== undefined
                                                                          && generateEmailWithAI(
                                                                            {
                                                                              user_message: item.sendEmailData.subject, instruction: 'casual', previous_response: item.sendEmailData.body, retry: !!item.sendEmailData.body,
                                                                            },
                                                                          );
                                                                      }}
                                                                      aria-hidden='true'
                                                                    >
                                                                      <ChatBubbleIcon />
                                                                      <span className='ms-3'>More casual</span>
                                                                    </div>
                                                                    <div
                                                                      className='chart-btn'
                                                                      onClick={(): void => {
                                                                        popupState.close();
                                                                        item.sendEmailData !== undefined
                                                                          && generateEmailWithAI(
                                                                            {
                                                                              user_message: item.sendEmailData.subject, instruction: 'friendly', previous_response: item.sendEmailData.body, retry: !!item.sendEmailData.body,
                                                                            },
                                                                          );
                                                                      }}
                                                                      style={{ borderBottom: '1px solid #E4E4E4' }}
                                                                      aria-hidden='true'
                                                                    >
                                                                      <ChatBubbleIcon />
                                                                      <span className='ms-3'>More friendly</span>
                                                                    </div>
                                                                  </Paper>
                                                                </Fade>
                                                              </ClickAwayListener>
                                                            )}
                                                          </Popper>
                                                        </div>
                                                      )}
                                                    </PopupState>
                                                  )}
                                              </div>
                                            )
                                            : (
                                              <ThemeProvider theme={customTheme}>
                                                <Tooltip title={(
                                                  <span>
                                                    {(focusedTask.name === '' || focusedTask.name === null) && (
                                                      <span>
                                                        You need to enter a
                                                        {' '}
                                                        <span style={{ color: '#00CFA1' }}>task name</span>
                                                        .
                                                        <br />
                                                      </span>
                                                    )}
                                                    {(item.sendEmailData === undefined || item.sendEmailData.subject === '')
                                                      && (
                                                        <span>
                                                          Please enter a subject for the email to generate with AI.
                                                        </span>
                                                      )}
                                                  </span>
                                                )}
                                                >
                                                  <IconButton className='merge-tag-div'>
                                                    <AIIconDisabled />
                                                  </IconButton>
                                                </Tooltip>
                                              </ThemeProvider>
                                            )}
                                        </div>
                                      </div>
                                      <StyledMenu
                                        id='job-menu'
                                        elevation={0}
                                        anchorOrigin={{
                                          vertical: 'bottom',
                                          horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                          vertical: 'top',
                                          horizontal: 'right',
                                        }}
                                        anchorEl={mergeTagAnchorEl}
                                        keepMounted
                                        open={Boolean(mergeTagAnchorEl)}
                                        onClose={(): void => { setMergeTagAnchorEl(null); }}
                                        PaperProps={{
                                          style: {
                                            borderRadius: 8,
                                            boxShadow: '0px 8px 10px 1px rgba(97, 97, 97, 0.14), 0px 3px 14px 2px rgba(97, 97, 97, 0.12), 0px 5px 5px -3px rgba(97, 97, 97, 0.2)',
                                            width: 322,
                                            padding: '0 0 8 0',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                          },
                                        }}
                                      >
                                        {renderMergeTagList(mergeFieldType, editorEdit, editorRefs, mergeFieldPosition, item, data, setData, focusedTask, setAddChanges, sendEmailIndex)}
                                      </StyledMenu>
                                    </div>
                                    <div className='send-email-div' style={{ marginLeft: '0px' }}>
                                      <EmailIcon />
                                      <p>Send email</p>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.type === 'subTask' && item !== undefined && item.subTasks !== undefined ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div className='sub-task-wrapper'>
                                    <div className='form-options-div'>
                                      {item.subTasks.map((subtask, indx) => (
                                        <div className='options-wrap d-flex align-items-center'>
                                          <h6 className='option-index'>{indx + 1}</h6>
                                          <Checkbox
                                            disabled
                                            sx={{
                                              fill: 'rgba(33, 33, 33, 0.6);',
                                              '&.Mui-checked': {
                                                fill: '#00CFA1',
                                              },
                                            }}
                                          />
                                          {(showSubtaskInputIndex === indx) && (formItemkey === item.unique_position_key)
                                            ? (
                                              <ClickAwayListener onClickAway={(): void => { setShowSubtaskInputIndex(-1); setFormItemkey(''); }}>
                                                <div className='option-input'>
                                                  <InputField
                                                    name='name'
                                                    placeholder='Type here or press enter to add another subtask'
                                                    type='text'
                                                    inputProps={{ maxLength: 250 }}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleSubTaskInputChange(e.target.value, item, subtask); }}
                                                    value={subtask.value}
                                                    autoFocus
                                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement> | React.KeyboardEvent<HTMLTextAreaElement>): void => {
                                                      if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        addNewSubTask(item, indx);
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </ClickAwayListener>
                                            )
                                            : (
                                              <div
                                                className='option-value-div'
                                                style={{
                                                  display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '5px 0px',
                                                }}
                                                aria-hidden='true'
                                                onClick={(): void => { setShowSubtaskInputIndex(indx); setFormItemkey(item.unique_position_key); }}
                                              >
                                                {subtask.value
                                                  ? <div className='option-value'>{subtask.value}</div>
                                                  : <div className='option-default-value'>Type here or press enter to add another subtask</div>}
                                                {item.subTasks !== undefined && item.subTasks.length > 1 && <div className='option-item-close' aria-hidden='true' onClick={(): void => { removeSubtaskOption(item, indx); }}><CloseIcon /></div>}
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                    </div>
                                    <div className='all-required-div'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span> Required (All subtasks)</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'shortText' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='form-disabled-input-wrap'>
                                      <InputField
                                        id='value'
                                        name='name'
                                        placeholder='Something will be typed here...'
                                        type='text'
                                        value=''
                                      />
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'longText' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='form-disabled-input-wrap'>
                                      <InputField
                                        id='value'
                                        name='name'
                                        placeholder='Something will be typed here...'
                                        type='text'
                                        value=''
                                        multiline
                                        rows={2}
                                      />
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'email' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='form-disabled-input-wrap'>
                                      <InputField
                                        id='value'
                                        name='name'
                                        placeholder='User will be able to type something here...'
                                        type='text'
                                        value=''
                                        startAdornment={<EmailIcon />}
                                      />
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'dropdown' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='form-disabled-input-wrap'>
                                      <InputField
                                        id='value'
                                        name='name'
                                        placeholder='An option will be selected from this list:'
                                        type='text'
                                        error={false}
                                        value=''
                                        endAdornment={<ArrowDropDownIcon />}
                                      />
                                    </div>
                                    <div className='form-options-div'>
                                      {item?.options?.map((option, indx) => (
                                        <div className='options-wrap'>
                                          <p className='option-index'>{indx + 1}</p>
                                          {showDropdownInputIndex === indx && (formItemkey === item.unique_position_key)
                                            ? (
                                              <ClickAwayListener onClickAway={(): void => { setShowDropdownInputIndex(-1); setFormItemkey(''); }}>
                                                <div className='option-input'>
                                                  <InputField
                                                    name='name'
                                                    placeholder='Type here or press enter to add another option'
                                                    type='text'
                                                    inputProps={{ maxLength: 250 }}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleOption(e.target.value, item, option); }}
                                                    value={option.label}
                                                    autoFocus
                                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement> | React.KeyboardEvent<HTMLTextAreaElement>): void => {
                                                      if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        addNewOption(item, indx);
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </ClickAwayListener>
                                            )
                                            : (
                                              <div
                                                className='option-value-div'
                                                style={{
                                                  display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '5px 0px',
                                                }}
                                                aria-hidden='true'
                                                onClick={(): void => { setShowDropdownInputIndex(indx); setFormItemkey(item.unique_position_key); }}
                                              >
                                                {option.label
                                                  ? <div className='option-value'>{option.label}</div>
                                                  : <div className='option-default-value'>Type here or press enter to add another option</div>}
                                                {item.options !== undefined && item.options.length > 1 && <div className='option-item-close' aria-hidden='true' onClick={(): void => { removeOption(item, indx); }}><CloseIcon /></div>}
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'radio' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='form-options-div'>
                                      {item?.options?.map((option, indx) => (
                                        <div className='options-wrap'>
                                          <p className='option-index'><RadioButtonUncheckedIcon /></p>
                                          {showRadioInputIndex === indx && (formItemkey === item.unique_position_key)
                                            ? (
                                              <ClickAwayListener onClickAway={(): void => { setShowRadioInputIndex(-1); setFormItemkey(''); }}>
                                                <div className='option-input'>
                                                  <InputField
                                                    name='name'
                                                    placeholder='Type here or press enter to add another option'
                                                    type='text'
                                                    inputProps={{ maxLength: 250 }}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleOption(e.target.value, item, option); }}
                                                    value={option.label}
                                                    autoFocus
                                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement> | React.KeyboardEvent<HTMLTextAreaElement>): void => {
                                                      if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        addNewOption(item, indx);
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </ClickAwayListener>
                                            )
                                            : (
                                              <div
                                                className='option-value-div'
                                                style={{
                                                  display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '5px 0px',
                                                }}
                                                aria-hidden='true'
                                                onClick={(): void => { setShowRadioInputIndex(indx); setFormItemkey(item.unique_position_key); }}
                                              >
                                                {option.label
                                                  ? <div className='option-value'>{option.label}</div>
                                                  : <div className='option-default-value'>Type here or press enter to add another radio button</div>}
                                                {item.options !== undefined && item.options.length > 1 && <div className='option-item-close' aria-hidden='true' onClick={(): void => { removeOption(item, indx); }}><CloseIcon /></div>}
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'multiChoice' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='form-disabled-input-wrap'>
                                      <InputField
                                        id='value'
                                        name='name'
                                        placeholder='Multiple options can be selected from this list:'
                                        type='text'
                                        error={false}
                                        value=''
                                        endAdornment={<ArrowDropDownIcon />}
                                      />
                                    </div>
                                    <div className='form-options-div'>
                                      {item?.options?.map((option, indx) => (
                                        <div className='options-wrap'>
                                          <p className='option-index'>{indx + 1}</p>
                                          {showMultichoiceInputIndex === indx && (formItemkey === item.unique_position_key)
                                            ? (
                                              <ClickAwayListener onClickAway={(): void => { setShowMultichoiceInputIndex(-1); setFormItemkey(''); }}>
                                                <div className='option-input'>
                                                  <InputField
                                                    name='name'
                                                    placeholder='Type here or press enter to add another option'
                                                    type='text'
                                                    inputProps={{ maxLength: 250 }}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleOption(e.target.value, item, option); }}
                                                    value={option.label}
                                                    autoFocus
                                                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement> | React.KeyboardEvent<HTMLTextAreaElement>): void => {
                                                      if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        addNewOption(item, indx);
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </ClickAwayListener>
                                            )
                                            : (
                                              <div
                                                className='option-value-div'
                                                style={{
                                                  display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', margin: '5px 0px',
                                                }}
                                                aria-hidden='true'
                                                onClick={(): void => { setShowMultichoiceInputIndex(indx); setFormItemkey(item.unique_position_key); }}
                                              >
                                                {option.label
                                                  ? <div className='option-value'>{option.label}</div>
                                                  : <div className='option-default-value'>Type here or press enter to add another option</div>}
                                                {item.options !== undefined && item.options.length > 1 && <div className='option-item-close' aria-hidden='true' onClick={(): void => { removeOption(item, indx); }}><CloseIcon /></div>}
                                              </div>
                                            )}
                                        </div>
                                      ))}
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'fileUpload' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='file-upload-div'>
                                      <PublishIcon />
                                      <p>File will be uploaded here</p>
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'image' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <FilePond
                                      disabled
                                      labelIdle='Drop your image or <span class="filepond--label-action">browse</span>'

                                    />
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'website' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='form-disabled-input-wrap'>
                                      <InputField
                                        id='value'
                                        name='name'
                                        placeholder='e.g., https://www.strada.ai/'
                                        type='text'
                                        error={false}
                                        value=''
                                        startAdornment={<LanguageIcon />}
                                      />
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'date' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='file-upload-div'>
                                      <DateRangeIcon />
                                      <p>Date will be set here</p>
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : item.form_type === 'numbers' ? (
                              <div className='task-form-item'>
                                <div className='editor-wrapper'>
                                  <div className='swap-up-down-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithUpperContent(index); }}><KeyboardArrowUpIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { swapWithLowerContent(index); }}><KeyboardArrowDownIcon /></div>
                                  </div>
                                  <div style={{ width: '100%' }}>
                                    <div className='form-input-wrap'>
                                      <InputField
                                        id='label'
                                        name='name'
                                        placeholder='Type Label here'
                                        type='text'
                                        inputProps={{ maxLength: 250 }}
                                        onKeyDown={handleInputKeyDown}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => { handleFormLabelChange(e.target.value, item); }}
                                        value={item.label}
                                        required
                                      />
                                    </div>
                                    <div className='form-disabled-input-wrap'>
                                      <InputField
                                        id='value'
                                        name='name'
                                        placeholder='Numbers will be typed here...'
                                        type='text'
                                        value=''
                                      />
                                    </div>
                                    <div className='form-is-required'>
                                      <Checkbox
                                        checked={item.is_required}
                                        sx={{
                                          fill: 'rgba(33, 33, 33, 0.6);',
                                          '&.Mui-checked': {
                                            fill: '#00CFA1',
                                          },
                                        }}
                                        onChange={(): void => { handleIsRequiredCheckbox(item); }}
                                      />
                                      <span>Required</span>
                                    </div>
                                  </div>
                                  <div className='delete-duplicate-wrapper'>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { setSelectedContentItem(item); setOpenDeleteContentBlock(true); }}><DeleteIcon /></div>
                                    <div className='delete-div' aria-hidden='true' onClick={(): void => { duplicateContentItem(item); }}><FileCopyIcon /></div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                        </div>
                      )}
                    </Draggable>
                  ))}

                  {provided.placeholder}
                  <div ref={bottomRef} style={{ height: '1px' }} />
                </div>
              )}
            </Droppable>
          </DragDropContext>

        ) : (
          <div>
            {!connectTaskSocket && (
              <div className='checklist-task-no-content'>
                Click the buttons on the right to add content
                <br />
                or
                {focusedTask !== undefined && focusedTask.name !== '' && focusedTask.name !== null && !socketOpen
                  ? (
                    <div
                      className='generate-task-wrap'
                      style={{ color: '#212121' }}
                      aria-hidden='true'
                      onClick={(): void => { setTaskDetail(''); setOpenTaskAI(true); }}
                    >
                      <AIIcon />
                      <p>
                        Generate task with AI
                      </p>
                    </div>
                  )
                  : (
                    <ThemeProvider theme={customTheme}>
                      <Tooltip title={!socketOpen ? (
                        <span>
                          Can’t generate task with AI.
                          <br />
                          {' '}
                          You need to enter a
                          {' '}
                          <span style={{ color: '#00CFA1' }}>task name</span>
                          .
                        </span>
                      ) : (
                        <span>
                          Can’t generate task while generating template tasks with AI.
                          {' '}
                        </span>
                      )}
                      >
                        <div
                          className='generate-task-wrap'
                          style={{ color: '#ABABAB', cursor: 'no-drop' }}
                        >
                          <AIIconDisabled />
                          <p>
                            Generate task with AI
                          </p>
                        </div>
                      </Tooltip>
                    </ThemeProvider>
                  )}
              </div>
            )}
          </div>
        )}
        <Dialog
          open={openDeleteContentBlock}
          onClose={(): void => {
            setOpenDeleteContentBlock(false);
          }}
        >
          <DialogContent style={{ width: 400, padding: '24px' }}>
            <div className='dialog-heading'>Delete this content block??</div>
            <span
              className='dialog-body'
              style={{
                fontSize: '14px', color: 'rgba(33, 33, 33, 0.6)', fontWeight: '400', marginTop: '15px',
              }}
            >
              This content block will be deleted.
            </span>
          </DialogContent>
          <DialogActions style={{ paddingRight: '20px' }}>
            <Button
              style={{ textTransform: 'inherit' }}
              onClick={(): void => {
                setOpenDeleteContentBlock(false);
              }}
              color='primary'
            >
              Cancel
            </Button>
            <Button variant='contained' onClick={(): void => { deleteTaskItem(selectedContentItem); }} style={{ textTransform: 'inherit', color: 'white', background: '#00CFA1' }} color='primary' autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        {connectTaskSocket && (
          <div ref={scollToRef} className='gpt-bar' style={{ width: '100%', padding: '0rem 6rem 2rem 6.5rem' }}>
            <div className='d-flex justify-content-between p-2 align-center'>
              <h5 className='questions-p'>
                Generating
                <span className='host'>
                  <span className='loading-gpt-res loading-0' />
                  <span className='loading-gpt-res loading-1' />
                  <span className='loading-gpt-res loading-2' />
                </span>
              </h5>
              <div
                className='generate-task-wrap'
                style={{ color: '#f44a41', padding: '6px 16px' }}
                aria-hidden='true'
                onClick={(): void => { handleTaskSocketClose(); }}
              >
                <p style={{ marginLeft: '0px' }}>
                  Stop
                  {' '}

                </p>
              </div>
            </div>

          </div>
        )}
      </div>
    </div>
  );
}
